import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Create";
import IconButton from "@mui/material/IconButton";

import { PM_CONFERENCES_PATH } from "../../../constants/router";

export const headRows = translate => [
  { id: "name", numeric: false, disablePadding: true, label: translate.name },
  { id: "product", numeric: false, disablePadding: false, label: translate.product },
  { id: "hostPasscode", numeric: false, disablePadding: false, label: translate.hostPasscode },
  { id: "guestPasscode", numeric: false, disablePadding: false, label: translate.guestPasscode },
  { id: "lastUsed", numeric: false, disablePadding: false, label: translate.lastUsed },
  { id: "active", numeric: true, disablePadding: false, label: translate.active },
  { id: "oneTime", numeric: true, disablePadding: false, label: translate.oneTime },
];

export const prepareRowData = conferences => {
  return conferences
    ? conferences.map(conference => {
        const row = {
          ...conference,
          name: conference.conferenceName,
        };
        delete row.conferenceName;
        return row;
      })
    : [];
};

const PMConferenceTableRow = ({ row, isItemSelected, labelId, handleClick }) => {
  return (
    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} selected={isItemSelected}>
      <TableCell sx={{ minWidth: "110px" }} padding="checkbox">
        <Checkbox
          onClick={event => handleClick(event, row.selectIndex)}
          checked={isItemSelected}
          slotProps={{ input: { "aria-labelledby": labelId } }}
        />
        <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PM_CONFERENCES_PATH}/${row.conferenceId}`}>
          <IconButton sx={theme => ({ mx: 1, maxHeight: "48px" })} size="large">
            <EditIcon />
          </IconButton>
        </NavLink>
      </TableCell>
      <TableCell /* component="th" */ id={labelId} scope="row" padding="none">
        {row.name}
      </TableCell>
      <TableCell align="left">{row.product}</TableCell>
      <TableCell align="left">{row.hostPasscode}</TableCell>
      <TableCell align="left">{row.guestPasscode}</TableCell>
      <TableCell align="left">{new Date(row.lastUsed).toDateString()}</TableCell>
      <TableCell align="right">
        {row.active ? <CheckIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
      </TableCell>
      <TableCell align="right">
        {row.oneTime ? <CheckIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
      </TableCell>
    </TableRow>
  );
};

PMConferenceTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default PMConferenceTableRow;
